export default "__VITE_ASSET__90cd31e3__"